import React, { useState, useEffect, useRef } from "react";
import { imsLoader, iconiMSAuthoring, GenAiPDFIcon, GenAiDOCIcon, GenAiPPTIcon } from '../../assets';
import "./GenAIAuthoring2Index.css";

import Dropzone from 'react-dropzone';
import ApiServices from "../../utils/apiServices";
import { v4 as uuidv4 } from 'uuid';
import { LocationOrigin, multiFilesAccept } from '../../utils/utilityServices';
import { Authentication } from "../../utils/authenticationUtilityServices";
import axios from "axios";
import AlertMessagePopUpModal from "../PopUp/AlertMessagePopUpModal";
import threadingService from "../../services/threadingService";
import { Modal } from "react-bootstrap";
import CreateUserPromptTemplate from "../PopUp/CreateUserPromptTemplate";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import AuthoringProjectService from "../../services/AuthoringProjectService"
import { UserData } from "../../auth/Authorization";


let _locationOrigin = LocationOrigin;
let _timeoutTime = (1000 * (300));
let ts = new threadingService();
let aps = new AuthoringProjectService();

const snippetLongStringForKeyword = (snippet, strLength = 22) => {
    if (snippet.length > strLength) {
        let text = snippet.substring(0, strLength)//cuts to 70
        text = text + `...`//adds (...) at the end to show that it's cut
        return text
    }
    return snippet;
}

const getAttachedFileName = (singleFile) => {
    let filename = singleFile.name.split('.').slice(0, -1).join('.');
    let fileExtention = singleFile.name.substring(singleFile.name.lastIndexOf('.') + 1, singleFile.name.length) || singleFile.name;
    filename = snippetLongStringForKeyword(filename);
    return `${filename} .${fileExtention}`;;
}

function GenAIAuthoring2Index() {
    const services = useRef(new ApiServices()).current;
    let guid = uuidv4();
    let threadGuid = uuidv4();
    const [sessionID] = useState(guid)
    const [threadID, setthreadID] = useState(threadGuid)
    const [newThreadID, setnewThreadID] = useState(threadGuid)
    const [updateAnyFile, setupdateAnyFile] = useState(false)
    const [startProject, setstartProject] = useState(true);
    const [uploadFilePlaceHolder, setuploadFilePlaceHolder] = useState("");
    const [uploadFilePlaceHolderTitle, setuploadFilePlaceHolderTitle] = useState("");
    const [, setisAttachedFile] = useState(false)
    const [selectProjectType, setselectProjectType] = useState(false)
    const [selectedProjectType, setselectedProjectType] = useState('');
    const [selectOption, setselectOption] = useState([])
    const [projectName, setprojectName] = useState('')
    const [isProjectName, setisProjectName] = useState(false)
    const [spinnerMessage, setspinnerMessage] = useState('')
    const [isProcessing, setisProcessing] = useState(false)
    const [documentSelected, setdocumentSelected] = useState(true)
    const [newAttachedFiles, setnewAttachedFiles] = useState([])
    const [alertMessageContent, setalertMessageContent] = useState("")
    const [alertMessageModelColor, setalertMessageModelColor] = useState("")
    const [alertMessageShowModal, setalertMessageShowModal] = useState(false)
    const [removedAttachedFileIndex, setremovedAttachedFileIndex] = useState(-1)
    const [manageAttachedIndex, setmanageAttachedIndex] = useState(false)
    const [attachedFiles, setattachedFiles] = useState([])
    const [prompt, setPrompt] = useState([])
    const [readingLevel] = useState(["8", "9", "10", "12"])
    const [selectedReadingLevel, setSelectedReadingLevel] = useState("8")
    const [attachedFilePopupCollapsed, setattachedFilePopupCollapsed] = useState(false)
    const [getProjectName, setgetProjectName] = useState([])
    const [errorMsg, setErrorMsg] = useState('')
    const inputRef = useRef(null);

    const history = useHistory()

    const onClickStartProject = () => {
        setstartProject(false)
    }

    const onClickExistingProject = () => {
        history.push('/GenAIExistingProject')
    }

    const handleChangeProjectType = (e) => {
        setselectedProjectType(e.target.value)
        setselectProjectType(true)
        setspinnerMessage('Please wait while fetching the prompts.')
        setisProcessing(true)
        getAllPrompts(e.target.value)
    }

    const renderFileIcon = (name) => {
        if (name.toLowerCase().endsWith('.pdf')) {
            return (<><img src={GenAiPDFIcon} alt="PDF" /> &nbsp;</>)
        }
        else if (name.toLowerCase().endsWith('.doc') || name.toLowerCase().endsWith('.docx')) {
            return (<><img src={GenAiDOCIcon} alt="DOC" /> &nbsp;</>)
        }
        else if (name.toLowerCase().endsWith('.ppt') || name.toLowerCase().endsWith('.pptx')) {
            return (<><img src={GenAiPPTIcon} alt="PPT" /> &nbsp;</>)
        }
        else if (name.toLowerCase().endsWith('.jpg')
            || name.toLowerCase().endsWith('.jpeg')
            || name.toLowerCase().endsWith('.png')
            || name.toLowerCase().endsWith('.gif')) {
            return (<><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="1" stroke-linecap="round" stroke-linejoin="miter">
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                    <polygon points="22 15.5 17 10 10.59 16.99 6.5 13 2 17.5 2 22 22 22 22 15.5" stroke-width="0" fill="#059cf7" opacity="0.1"></polygon>
                    <polygon points="22 15.5 17 10 10.59 16.99 6.5 13 2 17.5 2 22 22 22 22 15.5"></polygon>
                    <rect x="2" y="2" width="20" height="20" rx="0"></rect>
                    <line x1="6.99" y1="7" x2="7" y2="7" stroke-linecap="round" stroke-width="2"></line>
                </g>
            </svg> &nbsp;</>)
        }
        else {
            return (<svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="file" class="svg-inline--fa fa-file fa-fw fa-1x " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M320 464c8.8 0 16-7.2 16-16V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320zM0 64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64z"></path></svg>)
        }
    }
    const handleValidation = (field, value) => {
        let errors = {};
        let isValid = true;
        if (field.startsWith('wordLimit')) {
            let filterError = [];
            prompt.filter(val => val.prompt).forEach((val, index) => {
                if (!val.word_limit || Number.isNaN(parseInt(val.word_limit))) {
                    isValid = false;
                    errors[`wordLimit${index}`] = '*Please enter a numeric value.'
                    filterError.push(index);
                }
                else if (val.word_limit < 50) {
                    isValid = false;
                    errors[`wordLimit${index}`] = '*Please enter word limit greater than 50.'
                    filterError.push(index);
                }
            })
            if (filterError.length > 0) {
                isValid = false
            }
            setErrorMsg(errors)
            return isValid
        } else {
            if (value.length > 1) {
                errors[`${field}`] = '*Please enter character less than 100';
                isValid = false;
            }
        }
        setErrorMsg(errors)
        return (isValid)

    }
    const handleBlurProjectName = (e) => {
        if (e.target.value && e.target.value.trim()) {
            let filterProjectName = getProjectName.filter(x => x && x.toLowerCase() === e.target.value.trim().toLowerCase());
            if (filterProjectName && filterProjectName.length > 0) {
                setisProjectName(false);
                errorAlertMessage("Project Name already Exists. Kindly Select another Project Name.")
            } else {
                setisProjectName(true);
                //errorAlertMessage("Project Name Required, Please enter a project name.")
            }
        }
    }
    const handleChangeProjectName = (e) => {
        setprojectName(e.target.value)
    }

    const onDropRejected = (filestoUpload) => {
        if (filestoUpload.length > 5) {
            errorAlertMessage("You can only upload a maximum of 5 files");
        }
    }

    const successAlertMessage = (message) => {
        setalertMessageContent(message)
        setalertMessageModelColor("#00c12c")
        setalertMessageShowModal(true)
    }

    const closeAlertMessage = () => {
        setalertMessageContent("");
        setalertMessageModelColor("");
        setalertMessageShowModal(false);

    }
    const errorAlertMessage = (message) => {
        setalertMessageContent(message)
        setalertMessageModelColor("#de1327")
        setalertMessageShowModal(true)
    }


    const manageFilePlaceHolder = () => {
        let uploadFilePlaceHolder = '', uploadFilePlaceHolderTitle = '';
        if (attachedFiles.length > 0) {
            let singleFile = attachedFiles[0];
            uploadFilePlaceHolder = getAttachedFileName(singleFile);
            uploadFilePlaceHolderTitle = singleFile.name;
        }
        setuploadFilePlaceHolder(uploadFilePlaceHolder)
        setuploadFilePlaceHolderTitle(uploadFilePlaceHolderTitle)
        setisAttachedFile(attachedFiles.length > 0)
    }

    const handleRemoveAllAttachedFile = async () => {
        setuploadFilePlaceHolder("");
        setuploadFilePlaceHolderTitle("");
        setattachedFiles([]);
        setnewAttachedFiles([]);
        setisAttachedFile(false)
        setremovedAttachedFileIndex(-1)
        setupdateAnyFile(false)
        setdocumentSelected(false)
        await ts.deleteIndexBySessionId(sessionID);
        successAlertMessage("Documents removed successfully.");
    }


    const handleRemoveAttachedFile = async (index) => {
        setattachedFiles(attachedFiles.filter((file, fileIndex) => fileIndex !== index))
        if (attachedFiles.length > 0) {
            var threadGuid = uuidv4();
            if (attachedFiles.length === 1) {
                setremovedAttachedFileIndex(-1)
            } else {
                setremovedAttachedFileIndex(index)
            }

            setnewThreadID(threadGuid)
            // await multipleFilesUpload();
            await ts.deleteIndexBySessionId(sessionID);
            successAlertMessage("Document removed successfully.");
        } else {
            setuploadFilePlaceHolder("");
            setuploadFilePlaceHolderTitle("");
            setattachedFiles([]);
            setnewAttachedFiles([]);
            setisAttachedFile(false)
            setremovedAttachedFileIndex(-1)
            setupdateAnyFile(false)
            setdocumentSelected(true)
            await ts.deleteIndexBySessionId(sessionID);
            successAlertMessage("Document removed successfully.");
        }

    }

    const multipleFilesUpload = async (_attachedFiles) => {
        setisProcessing(true)
        var url = `${_locationOrigin}${process.env.REACT_APP_IMS_API_MULTI_ANSWERS}multi_upload`
        if (window.location.origin === 'https://predev-ims.jnj.com') {
            url = `${window.location.origin}${process.env.REACT_APP_IMS_API_MULTI_ANSWERS}multi_upload`
        }
        const formData = new FormData();
        attachedFiles.concat(_attachedFiles).filter((file, fileIndex) => fileIndex !== removedAttachedFileIndex).forEach((item, index) => {
            formData.append(`file${index + 1}`, item);
            formData.append(`fileGuid${index + 1}`, item.guid);
            formData.append(`newFileName${index + 1}`, item.newFileName);
        })
        formData.append(`fileCount`, attachedFiles.concat(_attachedFiles).filter((file, fileIndex) => fileIndex !== removedAttachedFileIndex).length);
        formData.append(`sessionID`, sessionID);
        formData.append(`threadID`, newThreadID);
        formData.append(`username`, localStorage.getItem('username').toLowerCase().replace(/"/g, ''));
        formData.append(`updateAnyFile`, updateAnyFile);

        const _headers = {
            'content-type': 'multipart/form-data'
        }
        if (await Authentication.isAccessTokenAvailable()) {
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
        }

        let config = {
            method: 'POST',
            url: url,
            headers: _headers,
            data: formData,
            timeout: _timeoutTime
        }
        await axios(config).then((resp) => {
            let response = resp.data;
            if (response.FileUpload) {
                let isRemoveFile = removedAttachedFileIndex !== -1;
                let isSingleFile = _attachedFiles.length === 1;
                setupdateAnyFile(false);
                setattachedFiles(attachedFiles.concat(_attachedFiles).filter((file, fileIndex) => fileIndex !== removedAttachedFileIndex));
                setremovedAttachedFileIndex(-1)
                setthreadID(newThreadID)
                // manageFilePlaceHolder();
                // setnewAttachedFiles([])
                if (isRemoveFile) {
                    successAlertMessage("Document removed successfully.");
                }
                else {
                    successAlertMessage(isSingleFile ? `Document uploaded successfully.` : `Documents uploaded successfully.`);
                }

            } else if (!response.FileUpload && response.Files && response.Files.length === 0) {
                errorAlertMessage(`Upload failed due to some reason. Kindly try after some time.<br /><br /><p class='alertmessage-file-label'>Documents name</p> - ${newAttachedFiles.map(x => x.name).join("<br /> - ")}`)
                setupdateAnyFile(true)
                setnewAttachedFiles([])
                setremovedAttachedFileIndex(-1)
                manageFilePlaceHolder()
            }
            else if (!response.FileUpload && response.Files && response.Files.length > 0) {
                let failedGuid = response.Files.map(x => x.Guid)
                let finalFaileAttached = attachedFiles.concat(_attachedFiles).filter((file, fileIndex) => fileIndex !== removedAttachedFileIndex).filter(x => failedGuid.includes(x.guid));
                errorAlertMessage(`Upload failed due to some reason. Kindly try after some time.<br /><br /><p class='alertmessage-file-label'>Documents name</p> - ${finalFaileAttached.map(x => x.name).join("<br /> - ")}`)
                setupdateAnyFile(true)
                setattachedFiles(attachedFiles.concat(_attachedFiles).filter((file, fileIndex) => fileIndex !== removedAttachedFileIndex).filter(x => !failedGuid.includes(x.guid)))
                setnewAttachedFiles([])
                setremovedAttachedFileIndex(-1)
                manageFilePlaceHolder()
            }
        }).catch((error) => {
            let isRemoveFile = removedAttachedFileIndex !== -1;
            setnewAttachedFiles([])
            setremovedAttachedFileIndex(-1)
            if (isRemoveFile) {
                errorAlertMessage(`Remove document failed to some reason. Kindly try after some time.`)
            } else {
                errorAlertMessage(`Upload failed due to some reason. Kindly try after some time.<br /><br /><p class='alertmessage-file-label'>Documents name</p> - ${newAttachedFiles.map(x => x.name).join("<br /> - ")}`)
            }
            console.log(error)
        }).finally(() => {
            setisProcessing(false)
        });
    }

    const openUploadedDocs = () => {
        setattachedFilePopupCollapsed(!attachedFilePopupCollapsed)
    }

    const fileInputChange = async (event) => {
        const files = event;
        let isImageUpload = (Object.keys(files).some(x =>
            files[x].name.toLowerCase().endsWith('.gif')
            || files[x].name.toLowerCase().endsWith('.jpeg')
            || files[x].name.toLowerCase().endsWith('.jpg')
            || files[x].name.toLowerCase().endsWith('.png')))
            || (attachedFiles.some(x =>
                x.name.toLowerCase().endsWith('.gif')
                || x.name.toLowerCase().endsWith('.jpeg')
                || x.name.toLowerCase().endsWith('.jpg')
                || x.name.toLowerCase().endsWith('.png')));



        let isDocUpload = (Object.keys(files).some(x =>
            files[x].name.toLowerCase().endsWith('.pdf')
            || files[x].name.toLowerCase().endsWith('.doc')
            || files[x].name.toLowerCase().endsWith('.docx')
            || files[x].name.toLowerCase().endsWith('.ppt')
            || files[x].name.toLowerCase().endsWith('.pptx')))
            || (attachedFiles.some(x =>
                x.name.toLowerCase().endsWith('.pdf')
                || x.name.toLowerCase().endsWith('.doc')
                || x.name.toLowerCase().endsWith('.docx')
                || x.name.toLowerCase().endsWith('.ppt')
                || x.name.toLowerCase().endsWith('.pptx')))

        if ((attachedFiles.length + Object.keys(files).length) > 5) {
            errorAlertMessage("You can only upload a maximum of 5 files");
        } else if (isImageUpload && isDocUpload) {
            errorAlertMessage("You can upload either image file or document file");
        } else if (isImageUpload && (attachedFiles.length + Object.keys(files).length) > 1) {
            errorAlertMessage("You can only upload a maximum of 1 image file");
        }
        else {
            let _attachedFiles = [];
            let isUploadSuccessfully = true;
            for (let i = 0; i < Object.keys(files).length; i++) {
                let file = files[i];
                if (file.name.toLowerCase().endsWith('.pdf')
                    || file.name.toLowerCase().endsWith('.jpg')
                    || file.name.toLowerCase().endsWith('.jpeg')
                    || file.name.toLowerCase().endsWith('.png')
                    || file.name.toLowerCase().endsWith('.gif')) {
                    file.guid = uuidv4();
                    file.newFileName = file.name;
                    _attachedFiles.push(file);
                } else {
                    setisProcessing(true)
                    let API_ENDPOINT = `${LocationOrigin}${process.env.REACT_APP_IMS_API_PREFIX}PreviewService/PDFMaker`;
                    //let API_ENDPOINT = `${LocationOrigin}${process.env.REACT_APP_IMS_API_PREFIX}PreviewService/PDFConverter`;
                    if (file.name.toLowerCase().endsWith('.doc') || file.name.toLowerCase().endsWith('.docx')) {
                        API_ENDPOINT += "?fileType=Document"
                    } else {
                        API_ENDPOINT += "?fileType=Presentation"
                    }
                    const formData = new FormData();
                    formData.append('form_filed_name', file)
                    const _headers = {
                        'content-type': 'multipart/form-data'
                    }
                    if (await Authentication.isAccessTokenAvailable()) {
                        const token = await Authentication.getAccessToken();
                        _headers.Authorization = `Bearer ${token}`;
                    }
                    try {
                        const res = await axios.post(API_ENDPOINT, formData, {
                        headers: _headers,
                        responseType: "blob",
                        timeout: _timeoutTime
                    });
                        let newFileName = file.name.split('.').slice(0, -1).join('.');
                        const fileName = `${newFileName}.pdf`;
                        const data = new Blob([res.data], { type: 'application/pdf' });
                        var newFile = new File([data], file.name, { type: 'application/pdf' });
                        newFile.guid = uuidv4();
                        newFile.newFileName = fileName;
                        _attachedFiles.push(newFile);
                    } catch (error) {
                        console.log(error);
                        isUploadSuccessfully = false;
                    }
                }
                if (!isUploadSuccessfully) {
                    break;
                }
            }
            if (!isUploadSuccessfully) {
                setnewAttachedFiles([])
                setremovedAttachedFileIndex(-1)
                setisProcessing(false)
                errorAlertMessage("Upload failed due to some reason. Kindly try after some time.");
            } else {
                var threadGuid = uuidv4();
                setnewAttachedFiles(_attachedFiles)
                setnewThreadID(threadGuid)
                if (_attachedFiles.length > 0) await multipleFilesUpload(_attachedFiles)
            }
        }
    }
    const onDropAccepted = async (filestoUpload) => {
        setdocumentSelected(false)
        await fileInputChange(filestoUpload)
    }

    const onDropError = (e) => {
        //console.log(e)
    }

    const fileInputChangeAdd = async (e) => {
        let resultArray = [];
        for (const key in e.target.files) {
            if (e.target.files.hasOwnProperty(key)) {
                resultArray.push(e.target.files[key]);
            }
        }
        setupdateAnyFile(true)
        setremovedAttachedFileIndex(-1)
        setmanageAttachedIndex(true)
        await fileInputChange(resultArray)
        if (inputRef.current) {
            inputRef.current.value = null;
        }
    }

    useEffect(() => {
        async function fetchData() {
            let res = await services.getAllProjectName()
            setselectOption(res)
        }
        fetchData();
        let uploadFilePlaceHolder = '', uploadFilePlaceHolderTitle = '';
        if (attachedFiles.length > 0) {
            let singleFile = attachedFiles[0];
            uploadFilePlaceHolder = getAttachedFileName(singleFile);
            uploadFilePlaceHolderTitle = singleFile.name;
        }
        setuploadFilePlaceHolder(uploadFilePlaceHolder)
        setuploadFilePlaceHolderTitle(uploadFilePlaceHolderTitle)
        setisAttachedFile(attachedFiles.length > 0)
    }, [attachedFiles, services])

    useEffect(() => {
        async function fetchProjectName() {
            let res = await aps.getAuthoringProjectNameData(UserData.sub)
            if(res.data){
            setgetProjectName(res.data)
            }
        }
        fetchProjectName()
    }, [])
    useEffect(() => {
        if (attachedFiles.length === 0) { setdocumentSelected(true) }
        setremovedAttachedFileIndex(-1)
    }, [attachedFiles, newAttachedFiles, manageAttachedIndex])

    const getAllPrompts = async (selectedProject) => {
        let selected_id = selectOption.filter(val => val.project_type_name === selectedProject)[0].id;
        await services.getAllPrompt(selected_id).then((res) => {
            setPrompt(res)
        }).catch((error) => {
            console.log(error)
        }).finally(() => {
            setisProcessing(false)
            setspinnerMessage('')
        })
    }
    const insert = (arr, index, newItem) => [
        // part of the array before the specified index
        ...arr.slice(0, index),
        // inserted item
        newItem,
        // part of the array after the specified index
        ...arr.slice(index)
    ]
    const handleAddNewUserPromptTemplate = (index) => {
        let promptNew = insert(prompt, index, { prompt: "", word_limit: '' })
        setPrompt(promptNew)
        /* if (isLastIndex) {
           this.scrollToBottom();
         }*/
    }
    const handleInputUserPromptTemplate = (index, value) => {
        let createUserPromp = prompt
        //createUserPromp[index].id = index
        createUserPromp[index].prompt = value;
        setPrompt(createUserPromp)
    }
    const handleRemoveUserPromptTemplate = (index) => {
        let createUserPromptTemplates = prompt.filter((x, i) => i !== index);
        setPrompt(createUserPromptTemplates)
    }
    const handleInputWordLimit = (index, value) => {
        let promtNew = prompt;
        //promtNew[index].id = index
        promtNew[index].word_limit = value;
        setPrompt(promtNew)
    }
    const renderCreateUserPromptTemplate = () => {
        return (<div className="user-prompt-template-prompt-area gen-ai-authoring-authoring-prompt-area" onClick={onHandelClickOutSideAttached} >{
            prompt.map((x, i) => {
                return (<CreateUserPromptTemplate key={`CreateUserPromptTemplate-${i}-${Math.random()}`} totalCounts={prompt.length}
                    handleInputUserPromptTemplate={handleInputUserPromptTemplate}
                    handleRemoveUserPromptTemplate={handleRemoveUserPromptTemplate}
                    handleAddNewUserPromptTemplate={handleAddNewUserPromptTemplate}
                    promptTemplateText={x.prompt}
                    currentIndex={i}
                    wordLimit={x.word_limit}
                    isFromCreateProject={true}
                    handleInputWordLimit={handleInputWordLimit}
                    errorMsg={errorMsg} />)
            })
        }
            {/*<div style={{ width: "100%" }}
            ref={(el) => { this.messagesEnd = el; }}>
          </div>*/}
        </div>);
    }

    const handleCreateDraft = () => {
        onHandelClickOutSideAttached();
        const isValid = handleValidation('wordLimit', prompt)
        if (isValid) {
            let promt_New = prompt.filter(x => x.prompt).map(val => {
                return {
                    prompt: val.prompt,
                    wordLimit: val.word_limit,
                    readingLevel: selectedReadingLevel
                }
            })

            if (projectName.length < 1) {
                errorAlertMessage("Project Name Required, Please enter a valid project name.")
            } else if (!isProjectName) {
                errorAlertMessage("Project Name already Exists. Kindly Select another Project Name.")
            } else if (projectName && projectName.trim().length > 100) {
                errorAlertMessage("Project Name should be less than 100")
            } else if (selectedProjectType.length < 1) {
                errorAlertMessage("Project Type Required, Please enter a project type.")
            } else if (attachedFiles && attachedFiles.length < 1) {
                errorAlertMessage("Please upload a file.")
            } else if (prompt && prompt.length < 1) {
                errorAlertMessage("Prompt Required, Please add atleast one prompt.")
            }
            else {
                let data = {
                    sessionID: sessionID,
                    threadID: threadID,
                    projectName: projectName.trim(),
                    projectType: selectedProjectType,
                    attachedFiles: attachedFiles,
                    prompts: promt_New,
                    newQuestion: promt_New[0].prompt
                }
                history.push({
                    pathname: '/genAIAuthoring2Search',
                    state: data // your data array of objects
                })
            }
        }
    }
    const onHandelClickOutSideAttached = (e) => {
        if (attachedFilePopupCollapsed) {
            setattachedFilePopupCollapsed(false)
        }
    }
    return (
        <div className="gen-ai-authoring-ask-question-wrapper">
            <div className="gen-ai-authoring-ask-question-inner-section" >
                {startProject ? <div className="GenAIAuthoring-new-and-existing-project-section">
                    <div className="GenAIAuthoring-new-and-existing-project-img-wrapper">
                        <img src={iconiMSAuthoring} alt="IMedicalAuthoring" height={42} />
                    </div>
                    <div className="GenAIAuthoring-new-and-existing-wrapper" onClick={onClickStartProject} >
                        <svg className="svg-inline--fa fa-plus fa-fw fa-1x " viewBox="0 0 24 24" role="img" xmlns="http://www.w3.org/2000/svg" aria-labelledby="newIconTitle" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none" color="#000000">
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path d="M19 14V22H2.99997V4H13"></path>
                                <path d="M17.4608 4.03921C18.2418 3.25817 19.5082 3.25816 20.2892 4.03921L20.9608 4.71079C21.7418 5.49184 21.7418 6.75817 20.9608 7.53921L11.5858 16.9142C11.2107 17.2893 10.702 17.5 10.1716 17.5L7.5 17.5L7.5 14.8284C7.5 14.298 7.71071 13.7893 8.08579 13.4142L17.4608 4.03921Z"></path> <path d="M16.25 5.25L19.75 8.75"></path>
                            </g>
                        </svg>Start a New Project
                    </div>
                    <div className="GenAIAuthoring-new-and-existing-wrapper" onClick={onClickExistingProject}>
                        <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="layer-group" className="svg-inline--fa fa-layer-group fa-fw " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M288 0c-8.5 0-17 1.7-24.8 5.1L53.9 94.8C40.6 100.5 32 113.5 32 128s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2L312.8 5.1C305 1.7 296.5 0 288 0zm-5.9 49.2C284 48.4 286 48 288 48s4 .4 5.9 1.2L477.7 128 293.9 206.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 128 282.1 49.2zM53.9 222.8C40.6 228.5 32 241.5 32 256s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2l-31.2-13.4L430 235.5 477.7 256 293.9 334.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 256 146 235.5 85.1 209.4 53.9 222.8zm0 128C40.6 356.5 32 369.5 32 384s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2l-31.2-13.4L430 363.5 477.7 384 293.9 462.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 384 146 363.5 85.1 337.4 53.9 350.8z"></path></svg>
                        Select and Existing Project
                    </div>

                </div> :
                    <div className="GenAIAuthoring-project-name-type-section">
                        <div className="GenAIAuthoring-new-and-existing-project-img-wrapper">
                            <img src={iconiMSAuthoring} alt="IMedicalAuthoring" height={42} />
                        </div>
                        <div className="GenAIAuthoring-project-name-type-wrapper">
                            <div className="GenAIAuthoring-project-name-type-label">Project Name: </div>
                            <div className="GenAIAuthoring-project-name-type-input">
                                <input className="GenAIAuthoring-project-name-input-text" type="text" id="projectname" value={projectName} name="projectname" onClick={onHandelClickOutSideAttached} onChange={handleChangeProjectName} onBlur={handleBlurProjectName} />
                                <div className="errorInvalidName" style={{ display: 'flex', justifyContent: 'flex-start', fontSize: '10px', marginTop: "0px", fontWeight: "800" }}>{errorMsg["projectName"]}</div>
                            </div>
                        </div>
                        <div className="GenAIAuthoring-project-name-type-wrapper">
                            <div className="GenAIAuthoring-project-name-type-label">Project Type: </div>
                            <div className="GenAIAuthoring-project-name-type-input">
                                <select
                                    className="GenAIAuthoring-project-type-dropdown"
                                    onChange={handleChangeProjectType}
                                    value={selectedProjectType}
                                    onClick={onHandelClickOutSideAttached}>
                                    <option value="" disabled selected hidden>Select Project Type</option>
                                    {selectOption.map((items) => {
                                        return (<option value={items.project_type_name}>{items.project_type_name}</option>)
                                    })}
                                </select>
                            </div>
                        </div>
                        {(attachedFiles.length < 1) && <>
                            <div className="GenAIAuthoring-project-name-type-wrapper">
                                <div className="GenAIAuthoring-project-name-type-label" >Upload Documents: </div>
                                <div className="GenAIAuthoring-project-upload-documents-input"></div>
                            </div>
                            <div className="GenAIAuthoring-main-row-drag-drop-section">
                                <Dropzone onDrop={acceptedFiles => { }}
                                    autoFocus={true}
                                    onDropRejected={onDropRejected}
                                    onDropAccepted={onDropAccepted}
                                    onError={onDropError}
                                    noClick={false}
                                    maxFiles={5}

                                >
                                    {({ getRootProps, getInputProps, isDragActive }) => (
                                        <section style={{ padding: '0'}} className="container">
                                            <div style={{ backgroundColor: isDragActive ? '#e4f3ff' : 'white' , height: '110px',justifyContent:'center'}}
                                                className={`GenAIAuthoring-main-row-drag-drop-dropzone dropzone ${isDragActive ? 'active-dropzone' : ''}`}
                                            >
                                                <div style={{ display : 'flex'}}{...getRootProps()}>
                                                    <input {...getInputProps()} />
                                                    <label style={{ cursor: "pointer", position: 'relative', /*right: '10px'*/ }}>
                                                        <svg className="svg-inline--fa fa-file fa-fw fa-1x " viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M9.81826 7.23019C9.81826 7.23019 9.81817 13.5601 9.81826 15.6701C9.81832 16.9891 10.6361 18.3075 12 18.3075C13.3639 18.3075 14.1818 16.9891 14.1818 15.6701C14.1818 13.5601 14.1818 8.28518 14.1818 6.1752C14.1818 4.06522 11.9438 2.87618 9.81826 3.01024C7.85859 3.13384 6.00018 4.06522 6.00018 6.1752C6.00018 8.28518 5.99977 12.5051 6.00018 15.6701C6.00066 19.3378 8.20735 22 11.9998 22C15.7923 22 17.9995 18.835 17.9999 15.6701C18.0002 12.5051 17.9999 7.23019 17.9999 7.23019" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                                            </g>
                                                        </svg>
                                                    </label>
                                                    <div style={{ fontWeight: 'bold' }}>Click to select a file or drag & drop documents here.</div>

                                                </div>
                                            </div>
                                        </section>
                                    )}
                                </Dropzone>
                            </div></>}
                        {(documentSelected && attachedFiles.length > 0) &&
                            <div className="GenAIAuthoring-project-name-type-wrapper">
                                <div className="GenAIAuthoring-project-name-type-label">Documents: </div>
                                <div>
                                    <div className="GenAIAuthoring-main-action-section-listfile" onClick={openUploadedDocs}>
                                        <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="file" class="svg-inline--fa fa-file fa-fw fa-1x " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M320 464c8.8 0 16-7.2 16-16V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320zM0 64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64z"></path></svg>
                                        <label className="GenAIAuthoring-main-action-section-upload" title={uploadFilePlaceHolderTitle} style={{ cursor: "pointer" }} >
                                            {uploadFilePlaceHolder}</label>
                                    </div>
                                    <div className="GenAIAuthoring-main-div-div-section-pdf" style={{ opacity: attachedFilePopupCollapsed ? '1' : '0' }}>

                                        <div className={"GenAIAuthoring-main-attachedfile-open"} >

                                            <div className="GenAIAuthoring-main-attachedfile-header-authoring">
                                                <div className="GenAIAuthoring-main-attachedfile-header-title" >
                                                    Attached Files
                                                </div>
                                                <div className="GenAIAuthoring-main-attachedfile-header-controle">
                                                    {attachedFiles.length < 5 &&
                                                        <>
                                                            <label for={`GenAIauthoring-authroingAttachedfile`} className="GenAIAuthoring-main-attachedfile-header-controle-add">
                                                                <div className="flex items-center leading-none justify-center gap-xs">
                                                                    <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="plus" className="svg-inline--fa fa-plus fa-fw fa-1x " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                                                        <path fill="currentColor" d="M248 72c0-13.3-10.7-24-24-24s-24 10.7-24 24V232H40c-13.3 0-24 10.7-24 24s10.7 24 24 24H200V440c0 13.3 10.7 24 24 24s24-10.7 24-24V280H408c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V72z"></path>
                                                                    </svg>
                                                                    <div class="text-align-center relative">Add</div>
                                                                </div>
                                                            </label>
                                                            <input ref={inputRef} type="file" name={`GenAIauthoring-authroingAttachedfile`} id={`GenAIauthoring-authroingAttachedfile`} multiple accept={multiFilesAccept} onChange={e => { fileInputChangeAdd(e) }} style={{ display: "none" }} />
                                                            &nbsp;
                                                        </>}
                                                    <button type="button" class="GenAIAuthoring-main-attachedfile-header-controle-delete" onClick={handleRemoveAllAttachedFile}>
                                                        <div class="flex items-center leading-none justify-center gap-xs">
                                                            <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="trash" className="svg-inline--fa fa-trash fa-fw fa-1x " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                                                <path fill="currentColor" d="M177.1 48h93.7c2.7 0 5.2 1.3 6.7 3.6l19 28.4h-145l19-28.4c1.5-2.2 4-3.6 6.7-3.6zM354.2 80L317.5 24.9C307.1 9.4 289.6 0 270.9 0H177.1c-18.7 0-36.2 9.4-46.6 24.9L93.8 80H80.1 32 24C10.7 80 0 90.7 0 104s10.7 24 24 24H35.6L59.6 452.7c2.5 33.4 30.3 59.3 63.8 59.3H324.6c33.5 0 61.3-25.9 63.8-59.3L412.4 128H424c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8H367.9 354.2zm10.1 48L340.5 449.2c-.6 8.4-7.6 14.8-16 14.8H123.4c-8.4 0-15.3-6.5-16-14.8L83.7 128H364.3z"></path>
                                                            </svg>
                                                            <div class="text-align-center relative">Clear</div>
                                                        </div>
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="GenAIAuthoring-main-attachedfile-items">
                                                <div className="GenAIAuthoring-main-attachedfile-item-wrapper">
                                                    {
                                                        attachedFiles.map((fileItem, fileIndex) => {
                                                            return (<div className="GenAIAuthoring-main-attachedfile-item" title={fileItem.name}>
                                                                <span className="GenAIAuthoring-main-attachedfile-item-span">
                                                                    {renderFileIcon(fileItem.name)}
                                                                    {getAttachedFileName(fileItem)}
                                                                </span>
                                                                <button style={{ background: "none" }} title="Clear Attached" onClick={e => handleRemoveAttachedFile(fileIndex)}>
                                                                    <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="xmark" class="svg-inline--fa fa-xmark fa-fw fa-1x " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                                                                        <path fill="currentColor" d="M345 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119L73 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l119 119L39 375c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L311 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L345 137z"></path></svg>
                                                                </button>
                                                            </div>)
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                {/*alertMessageShowModal && <AlertMessagePopUpModal color={alertMessageModelColor} content={alertMessageContent} showModal={alertMessageShowModal} handleClose={closeAlertMessage} />*/}

                            </div>
                        }
                        {(selectProjectType) && <>
                            {(selectProjectType && attachedFiles.length > 0) && <> <div className='GenAIAuthoring-main-prompt-container'>
                                <div className="authoring-prompt-label-container">
                                    <div className="GenAIAuthoring-div-label">Prompt: </div>
                                    <div className="GenAIAuthoring-div-label">Word Limit</div>
                                </div>
                                {(prompt && prompt.length > 0) && <>
                                    {renderCreateUserPromptTemplate()}
                                </>}
                            </div>
                                <div className="GenAIAuthoring-main-readinglevel-create-draf-container">
                                    <div className='GenAIAuthoring-main-prompt-reading-level-container' style={{ flexDirection: 'row' }}>
                                        <div className="GenAIAuthoring-div-label GenAIAuthoring-main-prompt-reading-level-label">Reading Level: </div>
                                        {/*<div className="user-prompt-word-limit" style={{ marginLeft : '0px'}}>100</div>*/}
                                        <select
                                            className="user-prompt-word-limit mx-0 wd-140 pd-2"
                                            onChange={(e) => { setSelectedReadingLevel(e.target.value) }}
                                            value={selectedReadingLevel} onClick={onHandelClickOutSideAttached}>
                                            <option value=''>No Reading Level</option>
                                            {readingLevel.map((val) => {
                                                return <option value={val}>{val}th grade</option>
                                            })}
                                        </select>
                                    </div>
                                    <div className='authoring2-create-draft prompt-ans'>
                                        <div className={"GenAIAuthoring-div-label pd-none create-draft"} onClick={handleCreateDraft}>Create Draft</div>
                                    </div>
                                </div>
                            </>}</>}
                    </div>}
                {isProcessing &&
                    <Modal
                        show={isProcessing}
                        size="lg md sm xs"
                        centered
                        aria-labelledby="contained-modal-title-vcenter"
                        dialogClassName="savePopUp"
                        className="document-processing-newthread"
                        backdropClassName="document-processing-newthread-backdrop"
                        scrollable={true}>
                        <div style={{ padding: "0 5%" }}>
                            <div style={{ fontSize: "14px", textAlign: "center" }}>
                                <Modal.Body>
                                    <img src={imsLoader} alt="" width={100} height={100} />
                                    <div className="saveModal-heading" style={{ color: "#0074B0" }}>{spinnerMessage ? spinnerMessage : `Please wait while uploading the document.`}</div>
                                </Modal.Body>
                            </div>
                        </div>
                    </Modal>}
                {alertMessageShowModal && <AlertMessagePopUpModal color={alertMessageModelColor} content={alertMessageContent} showModal={alertMessageShowModal} handleClose={closeAlertMessage} />}

            </div>
        </div>
    )
}
export default GenAIAuthoring2Index;